const regex = new RegExp('^[A-Z\\d]*(?:[\\s-][A-Z\\d]+){0,1}$');

/**
 * Directive to validate ZIP codes
 * @returns {{link: link, require: string, restrict: string}}
 */
export function zipCodeDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ngModel) => {
      attributes.$set('maxlength', 11);

      ngModel.$validators.zipCode = (value) => {
        return regex.test(value);
      };
    }
  };
}
